<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading" class="mb-3">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>{{ banner.id ? 'Editar Banner' : 'Novo Banner' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary lighten-3"
            @click="cancelar"
            :loading="loading"
            :disabled="loading"
          >Cancelar</v-btn>
          <v-btn
            depressed
            color="primary lighten-5"
            class="ml-2"
            @click="salvar"
            :loading="loading"
            :disabled="!form_valid"
          >Salvar</v-btn>
        </v-app-bar>

        <v-form ref="formbanner" v-model="form_valid" lazy-validation>
          <v-container fluid class="pa-0">
            <v-row dense class="pa-2">
              <v-col sm="8" class="pa-2">
                <v-row dense>
                  <v-col sm="12" class="pa-2">
                    <v-text-field
                      ref="nome"
                      v-model="banner.nome"
                      label="Nome"
                      :rules="rulesForm.nome"
                      hintText="Nome"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col sm="6" class="pa-2">
                    <as-date-picker-menu
                      ref="data"
                      label="Data Inicial"
                      :rules="rulesForm.data_inicio"
                      v-model="banner.data_inicio"
                    ></as-date-picker-menu>
                  </v-col>
                  <v-col sm="6" class="pa-2">
                    <as-date-picker-menu
                      ref="data"
                      label="Data Final"
                      :rules="rulesForm.data_fim"
                      v-model="banner.data_fim"
                    ></as-date-picker-menu>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col sm="6" class="pa-2">
                    <v-select
                      multiple
                      :items="['Clientes', 'Fornecedores', 'Representantes']"
                      label="Destino/Alvo"
                      ref="destino"
                      v-model="banner.destinatarios"
                    ></v-select>
                  </v-col>
                  <v-col sm="6" v-if="banner.id" class="pa-2">
                    <v-select
                      :items="['Em análise', 'Publicado']"
                      label="Publicação"
                      ref="publicacao"
                      v-model="banner.publicacao"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>

              <v-col sm="4" class="pa-2">
                <v-card height="100%">
                  <v-img
                    :src="banner.imagem"
                    height="200px"
                    v-if="banner.imagem"
                    @click="$refs.dialogoImagem.abrir()"
                  />
                  <v-layout
                    class="text-xs-center"
                    align-center
                    v-else
                    style="height:200px; background-color: lightgray"
                  >
                    <v-flex xs12 style="text-align: center">
                      <v-icon large>image</v-icon>
                    </v-flex>
                  </v-layout>

                  <v-card-actions>
                    <v-btn
                      depressed
                      color="primary darken-2"
                      type="file"
                      style="margin: 3px 2px 0px auto"
                      @click="abrirImagem"
                    >Carregar Imagem</v-btn>
                  </v-card-actions>
                </v-card>
                <input type="file" ref="input_logo" v-show="false" @change="mudarImagem" />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
    </v-container>

    <as-dialogo ref="dialogoImagem" title="Banner" max-width="1200px">
      <v-img
        :src="banner.imagem"
        v-if="banner.imagem"
        style="border-radius: 4px; border: 1px solid #eee"
      />
    </as-dialogo>
  </div>
</template>

<script>
import ServiceBanners from "@/services/banners.js";
import { ptDateFormat } from "@/util/dateFormat.js";
import moment from "moment";

export default {
  name: "BannersForm",
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      loadingCancelar: false,
      form_valid: true,
      ptDateFormat,
      banner: {
        id: "",
        nome: "",
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment()
          .add(7, "days")
          .format("YYYY-MM-DD"),
        imagem: null,
        destino: "Clientes",
        destinatarios: [],
        publicacao: ""
      },
      rulesForm: {
        nome: [value => !!value || "Obrigatório"],
        data_inicio: [value => !!value || "Obrigatório"],
        data_fim: [value => !!value || "Obrigatório"]
      },
      erros: {
        nome: false,
        data_inicio: false,
        data_fim: false
      }
    };
  },
  mounted() {
    if (this.$route.params.banner_id) {
      this.editar(this.$route.params.banner_id);
    }
    setTimeout(() => {
      this.$refs.nome.focus();
    }, 1000);
  },
  methods: {
    abrirImagem() {
      setTimeout(() => {
        this.$refs.input_logo.click();
      }, 1000);
    },
    mudarImagem() {
      let file = this.$refs.input_logo.files[0];

      let reader = new FileReader();
      reader.onload = () => {
        var dataURL = reader.result;
        this.banner.imagem = dataURL;
      };
      reader.readAsDataURL(file);
    },
    async salvar() {
      if (this.$refs.formbanner.validate()) {
        try {
          this.loading = true;
          if (!this.banner.id) {
            await ServiceBanners.salvar(this.banner);
          } else {
            await ServiceBanners.atualizar(this.banner);
          }
          this.$router.push("/banners");
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    async editar(banner_id) {
      try {
        this.loading = true;
        let banner = await ServiceBanners.editar(banner_id);
        this.banner = banner.data.banner;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao abrir a editção do banner", error);
      } finally {
        this.loading = false;
      }
    },
    cancelar() {
      this.$router.push("/banners");
    }
  }
};
</script>

<style></style>
